import { render, staticRenderFns } from "./HouseholdTypeTag.vue?vue&type=template&id=6ee8a936"
import script from "./HouseholdTypeTag.vue?vue&type=script&setup=true&lang=js"
export * from "./HouseholdTypeTag.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports